import React, {  } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import Button from '@mui/material/Button'
import CRUDForm from '../../containers/CRUDForm'
import { ProjectTaskActions } from '../../actionsets'
import { ModelStatus } from '../../constants'
import { roleCheck } from '../../utils'
import { ProjectTaskAPI } from '../../api'
import { RequestService } from '../../services'
import { LabeledSelect, LabeledCheckbox, DatePicker } from 'components'


export class ProjectTaskForm extends CRUDForm{

  static propTypes = {
    dispatch: PropTypes.func,
    onSubmitted: PropTypes.func,
    onCancel: PropTypes.func,
    projectId: PropTypes.any.isRequired,
  }

  static styles = {
    fields: {
      marginBottom: 20,
      marginTop: 10,
      display: 'flex',
      flexDirection: 'column',
    },
    leftField: {
      flex: 1,
      marginRight: 10,
    },
    rightField: {
      flex: 1,
      marginLeft: 10,
    },
    actions: {
      float: 'right'
    },
  }

  static defaultProps = {
    projects: []
  }

  constructor(props){
    super(props)
    this.state = {
      errors: {},
      submissionErrors: [],
      projectId: this.props.projectId || '',
      name: '',
      code: '',
      source: '',
      description: '',
      url: '',
      billable: false,
      startDate: null,
      endDate: null,
      projectStatus: '',
      customerStatus: '',
      status: ModelStatus.default,
    }
    ProjectTaskActions.bindActions(this)
  }

  loadCreateItem = () => {
    if(this.createMode && !roleCheck(this.props.role, 'admin')){
      this.props.dispatch(push('/'))
    }
  }

  loadEditItem = async () => {
    if(this.userId !== this.editId && !roleCheck(this.props.role, 'admin')){
      this.props.dispatch(push('/'))
      return
    }
    try{

      const { body: { data: { attributes: { name, code, source, url, description, projectId, billable, startDate, endDate, status, projectStatus, customerStatus }}}} = await ProjectTaskAPI.show(this.editId)(RequestService)
      this.setState({
        name, code, source, url, description, projectId:  String(projectId), billable, startDate, endDate, status, projectStatus, customerStatus
      })
    }catch(err){
      this.setState({ submissionErrors: [{ detail: `Couldn't find project task with id ${this.editId}`, source: { pointer:'' }}] })
    }
  }

  submit = async () => {
    if(!this.validate())
      return

    const { name, code, source, url, description, projectId, billable, startDate, endDate, status } = {...this.state }
    const params = { name, code, source, url, description, projectId, billable, startDate, endDate, status }

    let action
    if(this.editMode){
      action = this.actions.updateProjectTask(this.editId, params)
    }else{
      action = this.actions.createProjectTask(params)
    }

    try{
      await action
      this.props.onSubmitted && this.props.onSubmitted()
    } catch(err){
      const { body: { errors: submissionErrors }} = err
      this.setState({ submissionErrors })
    }
  }

  validate = () => {
    let requiredFields = ['name', 'projectId', 'startDate', 'status']
    const errors = this.requireFields(requiredFields)
    this.setState({ errors })
    return Object.keys(errors).length === 0
  }

  get editId(){
    return this.props.editId
  }

  get userId(){
    return this.props.user.id
  }

  get derivedStatusError() {
    if (this.state.projectStatus === ModelStatus.archived) return 'The project has been archived'
    if (this.state.customerStatus === ModelStatus.archived) return 'The project customer has been archived'
    return ''
  }

  render = () =>
    <div>
      <div style={ProjectTaskForm.styles.fields}>
        {this.renderSubmissionErrors()}

        <div style={{display: 'flex'}}>
          <TextField
            style={ProjectTaskForm.styles.leftField}
            label="Name"
            value={this.state.name}
            onChange={this.onInputValueChange('name')}
            {...this.fieldErrors('name')}
          />

          <TextField
            style={ProjectTaskForm.styles.rightField}
            label="Description"
            value={this.state.description}
            onChange={this.onInputValueChange('description')}
            {...this.fieldErrors('description')}
          />
        </div>

        <div style={{display: 'flex'}}>
          <DatePicker
            clearable
            style={ProjectTaskForm.styles.leftField}
            label="Start Date"
            value={this.state.startDate}
            {...this.fieldErrors('startDate')}
            onChange={this.onInputValueChange('startDate')}
            autoOk
          />

          <DatePicker
            clearable
            style={ProjectTaskForm.styles.rightField}
            label="End Date"
            value={this.state.endDate}
            {...this.fieldErrors('endDate')}
            onChange={this.onInputValueChange('endDate')}
            autoOk
          />
        </div>

        <div style={{display: 'flex'}}>
          <TextField
            style={ProjectTaskForm.styles.leftField}
            label="URL"
            value={this.state.url}
            onChange={this.onInputValueChange('url')}
            {...this.fieldErrors('url')}
          />

          <LabeledSelect
            style={ProjectTaskForm.styles.rightField}
            label="Status"
            value={this.state.status}
            onChange={this.onInputValueChange('status')}
            error={!!(this.state.errors.status || this.derivedStatusError)}
            helperText={this.state.errors.status || this.derivedStatusError}
            disabled={!!this.derivedStatusError}
          >
            <MenuItem value='active' children='Active' />
            <MenuItem value='archived' children='Archived' />
          </LabeledSelect>
        </div>
        <div>
          <LabeledCheckbox
            color="primary"
            label="Billable"
            checked={this.state.billable || false}
            onChange={({ target: { checked }}) => { this.setState({billable: checked})}}
          />
        </div>
      </div>
      <div style={ProjectTaskForm.styles.actions}>
        <Button children="Cancel" style={{marginRight: 10}} onClick={this.props.onCancel} />
        <Button variant="contained" color="primary" children='Save' onClick={this.submit} />
      </div>
    </div>
}

export default connect(({session}) => session)(ProjectTaskForm)
